export default {
  namespaced: true,
  billing_finance: {
    title: "Finance",
    region: "Region",
    month: "Month",
    year: "Year",
    state: "State",
    rems: "REMS",
    security_company: "Security Company",
    job_description: "Job Description",
    number_of_services: "Number of Services",
    service_days: "Service Days",
    hours: "Hours",
    cost_per_shift: "Cost per Shift",
    type_of_guard: "Type of Guard",
    work_schedule: "Work Schedule",
    save_successfully: "Saved successfully",
    delete_many: "Delete records",
    delete: "Delete records",
    delete_question: "Are you sure you want to delete the filtered records?",
    delete_description: " records will be deleted.",
  }
}